import { CircularProgress, CircularProgressProps, Box, BoxProps } from '@mui/material';


export const Loader = ({ size, thickness, color, ...props }: Omit<BoxProps, 'color'> & CircularProgressProps ) => (
  <Box
    color="inherit"
    width="100%"
    height="100%"
    display="flex"
    alignItems="center"
    justifyContent="center"
    {...props}
  >
    <CircularProgress
      thickness={thickness}
      color={color || 'inherit'}
      size={size}
    />
  </Box>
);
